<template>
    <div class="cost-approval">
      <!-- 页面标题 -->
      <div class="page-header">
        <h2>费用审批</h2>
        <div class="header-summary">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="summary-card">
                <div class="card-title">待审批</div>
                <div class="card-amount">{{ pendingCount }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="summary-card">
                <div class="card-title">已通过</div>
                <div class="card-amount">{{ approvedCount }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="summary-card">
                <div class="card-title">已拒绝</div>
                <div class="card-amount">{{ rejectedCount }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
  
      <!-- 操作栏 -->
      <div class="operation-bar">
        <div class="right-operations">
          <el-select
            v-model="filterType"
            placeholder="费用类型"
            clearable
            style="width: 120px; margin-right: 10px"
            @change="handleTypeChange"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 330px; margin-right: 10px"
            @change="handleDateChange"
          />
          <el-input
            v-model="searchKeyword"
            placeholder="搜索备注"
            prefix-icon="el-icon-search"
            style="width: 200px"
            @input="handleSearch"
          />
        </div>
      </div>
  
      <!-- 表格 -->
      <el-card class="table-card" shadow="hover">
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column prop="date" label="日期" width="120">
            <template #default="scope">
              {{ formatDate(scope.row.date) }}
            </template>
          </el-table-column>
          <el-table-column prop="title" label="申请人" width="120" />
          <el-table-column prop="carNumber" label="车号" width="120" />
          <el-table-column prop="type" label="费用类型" width="120">
            <template #default="scope">
              <el-tag :type="getTagType(scope.row.type)">
                {{ typeMap[scope.row.type] || scope.row.type }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="金额" width="150">
            <template #default="scope">
              <span class="amount">¥ {{ Number(scope.row.amount || 0).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="120">
            <template #default="scope">
              <el-tag :type="getStatusType(scope.row.status)">
                {{ statusMap[scope.row.status] || scope.row.status }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" show-overflow-tooltip/>
          <el-table-column label="操作" width="200" fixed="right">
            <template #default="scope">
              <el-button
                v-if="scope.row.status === 'pending'"
                type="success"
                size="small"
                @click="handleApprove(scope.row)"
              >通过</el-button>
              <el-button
                v-if="scope.row.status === 'pending'"
                type="danger"
                size="small"
                @click="handleReject(scope.row)"
              >拒绝</el-button>
            </template>
          </el-table-column>
        </el-table>
  
        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            :current-page="currentPage"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-card>
    </div>
  </template>
  
  <script>
  import { formatDate } from '@/utils/date'
  import { getCostList, updateCostStatus, getCostCount } from '@/api/costs'
  
  export default {
    name: 'CostApproval',
    data() {
      return {
        // 表格数据
        tableData: [],
        searchKeyword: '',
        currentPage: 1,
        pageSize: 10,
        total: 0,
  
        pendingCount: 0,
        approvedCount: 0,
        rejectedCount: 0,
  
        // 费用类型映射
        typeMap: {
          kitchen: '厨房支出',
          repair: '维修支出',
          salary: '工资支出',
          fuel: '燃油支出',
          other: '其他支出'
        },
  
        // 状态映射
        statusMap: {
          pending: '待审批',
          approved: '已通过',
          rejected: '已拒绝'
        },
  
        filterType: '',
        dateRange: null,
        typeOptions: [
          { value: 'kitchen', label: '厨房支出' },
          { value: 'repair', label: '维修支出' },
          { value: 'salary', label: '工资支出' },
          { value: 'fuel', label: '燃油支出' },
          { value: 'other', label: '其他支出' }
        ],
        listQuery: {
          current: 1,
          size: 10,
          type: '',
          startTime: '',
          endTime: '',
          keyword: ''
        }
      }
    },
  
    created() {
      this.fetchData()
    },
  
    methods: {
      formatDate,
  
      // 获取列表数据
      async fetchData() {
        try {
          // 获取列表数据
          const listRes = await getCostList({
            page: this.currentPage,
            pageSize: this.pageSize,
            type: this.filterType || '',
            keyword: this.searchKeyword || '',
            startTime: this.dateRange ? this.dateRange[0] : '',
            endTime: this.dateRange ? this.dateRange[1] : ''
          })
          
          console.log('查询参数:', {
            page: this.currentPage,
            pageSize: this.pageSize,
            type: this.filterType,
            keyword: this.searchKeyword,
            dateRange: this.dateRange
          })
          
          console.log('列表响应数据:', listRes)
          console.log('列表具体数据:', listRes.data)
          
          // 获取统计数据
          const countRes = await getCostCount()
          
          if (listRes.code === 200) {
            // 检查数据结构
            if (Array.isArray(listRes.data)) {
              this.tableData = listRes.data
            } else if (listRes.data && Array.isArray(listRes.data.records)) {
              this.tableData = listRes.data.records
            } else {
              this.tableData = []
            }
            
            // 设置总数
            if (listRes.data && typeof listRes.data.total === 'number') {
              this.total = listRes.data.total
            } else {
              this.total = this.tableData.length
            }
            
            console.log('处理后的表格数据:', this.tableData)
          }

          if (countRes.code === 200) {
            this.pendingCount = countRes.data.pending || 0
            this.approvedCount = countRes.data.approved || 0
            this.rejectedCount = countRes.data.rejected || 0
          }
        } catch (error) {
          console.error('获取数据失败:', error)
          this.$message.error('获取数据失败')
        }
      },
  
      // 处理审批通过
      async handleApprove(row) {
        try {
          const res = await updateCostStatus({
            id: row.id,
            status: 'approved'
          })
          console.log('更新响应:', res)
          
          if (res.code === 200) {
            this.$message.success('审批通过成功')
            await this.fetchData()
          } else {
            this.$message.error(res.message || '操作失败')
          }
        } catch (error) {
          console.error('审批失败:', error)
          this.$message.error('操作失败')
        }
      },
  
      // 处理审批拒绝
      async handleReject(row) {
        try {
          const res = await updateCostStatus({
            id: row.id,
            status: 'rejected'
          })
          console.log('更新响应:', res)
          
          if (res.code === 200) {
            this.$message.success('已拒绝申请')
            await this.fetchData()
          } else {
            this.$message.error(res.message || '操作失败')
          }
        } catch (error) {
          console.error('拒绝失败:', error)
          this.$message.error('操作失败')
        }
      },
  
      getTagType(type) {
        const typeMap = {
          kitchen: 'success',
          repair: 'warning',
          salary: 'primary',
          fuel: 'danger',
          other: 'info'
        }
        return typeMap[type]
      },
  
      getStatusType(status) {
        const statusMap = {
          pending: 'warning',
          approved: 'success',
          rejected: 'danger'
        }
        return statusMap[status]
      },
      
      handleSizeChange(size) {
        this.pageSize = size
        this.fetchData()
      },
  
      handleCurrentChange(page) {
        this.currentPage = page
        this.fetchData()
      },
  
      handleSearch() {
        this.currentPage = 1
        this.fetchData()
      },
  
      handleTypeChange(val) {
        this.filterType = val
        this.currentPage = 1
        this.fetchData()
      },
  
      handleDateChange(val) {
        this.dateRange = val
        this.currentPage = 1
        this.fetchData()
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .cost-approval {
    padding: 20px;
    background-color: #f0f2f5;
    min-height: calc(100vh - 40px);
  
    .page-header {
      margin-bottom: 24px;
  
      h2 {
        margin: 0 0 16px;
        color: #1f2f3d;
        font-weight: 500;
      }
  
      .header-summary {
        margin-top: 20px;
      }
  
      .summary-card {
        background: #fff;
        padding: 15px;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
  
        .card-title {
          color: #909399;
          font-size: 14px;
          margin-bottom: 8px;
        }
  
        .card-amount {
          color: #303133;
          font-size: 24px;
          font-weight: bold;
        }
      }
    }
  
    .operation-bar {
      background: #fff;
      padding: 16px;
      border-radius: 4px;
      margin-bottom: 16px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
    }
  
    .table-card {
      margin-bottom: 20px;
    }
  
    .amount {
      color: #67c23a;
      font-weight: bold;
    }
  
    .pagination-container {
      padding: 15px 0;
      text-align: right;
    }
  }
  </style>